import { ChangeDetectionStrategy, Component, DOCUMENT, inject, Renderer2 } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { THEME_SWITCHER, ThemeSwitcher } from '@ion/misc';
import { TranslateService } from '@ngx-translate/core';
import { TUI_DARK_MODE, TuiRoot } from '@taiga-ui/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TuiRoot, RouterOutlet],
})
export class AppComponent {
  translate = inject(TranslateService);
  private readonly document = inject<Document>(DOCUMENT);
  private readonly renderer = inject(Renderer2);
  private readonly ui = inject<ThemeSwitcher>(THEME_SWITCHER, { optional: true });

  protected readonly darkMode = inject(TUI_DARK_MODE);

  constructor() {
    const translate = this.translate;
    const document = this.document;
    const ui = this.ui;

    // de-DE isn't currently used, but we kept it in this TranslateService configuration so it
    // can still easily be tested during local environment.
    translate.addLangs(['en-US', 'de-DE']);
    translate.setFallbackLang('en-US').subscribe();
    translate.use('en-US').subscribe();

    // const browserLang = translate.getBrowserLang();
    // translate.use(browserLang.match(/en|de/) ? browserLang : 'en');

    ui?.selectTheme().subscribe(theme => {
      this.renderer.setAttribute(document.body, 'data-theme', theme);
    });
  }
}
